import styled from '@emotion/styled';
import { input } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

interface TextareaElementPropsType {
    isError?: boolean;
    isEmpty?: boolean;
    isReadOnly?: boolean;
}

export const Wrapper = styled('div', { label: 'Wrapper' })<TextareaElementPropsType>`
    display: flex;
    flex-flow: column wrap;
    flex: 1 0 auto;
    margin-bottom: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }

    .cke_chrome, textarea {
        border-width: 1px;
        border-style: solid;
        border-color: ${({ isError, isEmpty }): string => isError === true ? input.borderColorTertiary : isEmpty === true ? input.borderColor : input.borderColorSecondary};
    }

    .cke_bottom {
        opacity: ${({ isReadOnly }): string => isReadOnly === true ? '0.5' : '1'};
    }

    .cke_contents {
        opacity: ${({ isReadOnly }): string => isReadOnly === true ? '0.5' : '1'};
    }
`;

export const TextareaElement = styled('textarea', { label: 'TextareaElement' })<TextareaElementPropsType>`
    box-sizing: border-box;
    color: ${input.txtColor};
    font-family: var(--fontFamilyPrimary);
    height: 80px;
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.regular};
    line-height: 1.4;
    background-color: ${input.bgColor};
    padding: 8px;
    outline: none;
    resize: none;

    &::placeholder {
        font-weight: ${fontWeight.regular};
        color: ${input.txtColorSecondary};
    }

    &:read-only, &:disabled {
        background-color: ${input.readOnly.bgColor};
        cursor: not-allowed;
    }
`;
